import { text_mod_78, } from "../text/Text.js";
export const module78 = {
  title:
    "Літера А",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_78,
    },
  ]
};